module.exports = __webpack_public_path__ + "static/media/context-questions-icon.4d7e6e08.svg";